import { Box, Center, Icon, Spinner, Text } from "@chakra-ui/react";
import FancyBearImage from "components/FancyBearImage";
import { FaCheck } from "react-icons/fa";

type FancyBearCardProps = {
  tokenId: number;
  isSelected?: boolean;
  isBusy?: boolean;
  isDisabled?: boolean;
  badgeText?: string;
  onClick?: (tokenId: number) => void;
};

const FancyBearCard = ({
  tokenId,
  isDisabled = false,
  isSelected = false,
  isBusy = false,
  badgeText,
  onClick,
}: FancyBearCardProps) => (
  <Box
    bg="bright.500"
    p="2"
    w="full"
    outline="2px solid"
    userSelect="none"
    outlineColor={isSelected ? "dark.base" : "transparent"}
    cursor={isDisabled ? "not-allowed" : "pointer"}
    transition="all 0.15s"
    tabIndex={0}
    onClick={() => {
      if (!isDisabled && onClick) {
        onClick(tokenId);
      }
    }}
  >
    <Box position="relative">
      <FancyBearImage tokenId={tokenId} isDisabled={isDisabled || isBusy} />

      <Center
        position="absolute"
        top="-2"
        left="-2"
        bg="bright.500"
        w="10"
        h="10"
        zIndex="dropdown"
        opacity={isSelected ? "1" : "0"}
        transition="opacity 0.2s"
      >
        <Icon as={FaCheck} w={4} h={4} color="primary.500" />
      </Center>

      <Center
        position="absolute"
        top="-2"
        right="-2"
        bg="bright.500"
        w="10"
        h="10"
        zIndex="dropdown"
        opacity={isBusy ? "1" : "0"}
        transition="opacity 0.2s"
      >
        {isBusy && <Spinner size="sm" color="primary.500" thickness="3px" />}
      </Center>

      {badgeText && (
        <Box
          position="absolute"
          top="50%"
          left="50%"
          bg="dark.500"
          px="4"
          py="2"
          transform="translate(-50%, -50%)"
        >
          <Text fontWeight="600" fontSize="sm" color="bright.400">
            {badgeText}
          </Text>
        </Box>
      )}
    </Box>

    <Box px="2" pt="3" pb="1">
      <Text fontWeight="600">#{tokenId}</Text>
    </Box>
  </Box>
);

export default FancyBearCard;
